import React, { useState } from "react";
import { useUser } from "./UserContext";
import useActiveEmergency from "../hooks/useActiveEmergency";
import { startEmergency } from "./emergencyData";

// The one deliberate place to START a school-wide emergency (lives in the sidebar
// drawer). Guarded by a confirm so a stray/kid tap can't fire it, and it hides
// itself once an emergency is already active — from then on the app-wide banner is
// the one-tap way into the accountability screen, so no second trigger is needed.
export default function EmergencyTriggerButton({ className = "", onDone, label = "🚨 Start Emergency" }) {
  const { user, schoolId, teacherName } = useUser();
  const { emergency } = useActiveEmergency();
  const [busy, setBusy] = useState(false);

  if (emergency) return null; // already live → the banner is the way in

  const handleClick = async (e) => {
    e.stopPropagation(); // don't let a Cancel also close the drawer
    const ok = window.confirm(
      "Start a school-wide EMERGENCY?\n\nThis immediately alerts every staff member to account for their students. Only do this in a real emergency.",
    );
    if (!ok) return;
    setBusy(true);
    try {
      await startEmergency(schoolId, user, teacherName, false);
      if (onDone) onDone(); // e.g. close the drawer
    } catch (err) {
      console.error("[EmergencyTrigger] start failed:", err);
      window.alert("Couldn't start the emergency — check your connection and try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button type="button" className={className} disabled={busy || !schoolId} onClick={handleClick}>
      {busy ? "Starting…" : label}
    </button>
  );
}
